module.exports = __webpack_public_path__ + "img/kos_no.a70e04e9.png";